var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://authorizelocal.com"}},[_c('img',{attrs:{"id":"NavbarLogo","src":require("@/assets//images/logo/logo_wide.png")}})])
}]

export { render, staticRenderFns }